//frontend/src/components/StatusCounters.js
// This React component is a presentational stats card, showing driver counts (Total, Active, Reserved, Banned) and optionally highlighting when the active count reaches the agency’s capacity.
import React from 'react';

/**
 * Presentational counters card.
 * Props:
 *  - title?: string
 *  - counts: { Total: number, Active: number, Reserved: number, Banned: number }
 *  - activeCap?: number | null  // if provided, shows "Active X / cap"
 *  - className?: string
 */
export default function StatusCounters({ title = 'Drivers', counts, activeCap = null, className = '' }) {
  const atLimit = Number.isFinite(activeCap) && counts?.Active >= activeCap;

  const Stat = ({ label, value, highlight = false }) => (
    <div className="flex flex-col items-center p-3 bg-gray-50 rounded-lg">
      <div className={`text-xl font-semibold ${highlight ? 'text-red-600' : 'text-gray-800'}`}>
        {value}
      </div>
      <div className="text-xs text-gray-500">{label}</div>
    </div>
  );

  const safe = k => (counts && Number.isFinite(counts[k]) ? counts[k] : 0);

  const activeDisplay = Number.isFinite(activeCap)
    ? `${safe('Active')} / ${activeCap}`
    : `${safe('Active')}`;

  return (
    <div className={`bg-white rounded-lg shadow p-4 mb-4 ${className}`}>
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium text-gray-800">{title}</h3>
      </div>
      <div className="grid grid-cols-4 gap-3 mt-3">
        <Stat label="Total"   value={safe('Total')} />
        <Stat label="Active"  value={activeDisplay} highlight={atLimit} />
        <Stat label="Reserved" value={safe('Reserved')} />
        <Stat label="Banned"  value={safe('Banned')} />
      </div>
    </div>
  );
}
